module.exports = __webpack_public_path__ + "static/media/cart-saved.e52cbc45.png";